import { createStateSelectorHook } from 'src/lib/sweetState';
import { PerformanceStore } from '../store/performance/PerformanceStore';
import { INTEGRATION_CHANNELS } from 'src/data/performance';

const usePerformanceState = createStateSelectorHook(PerformanceStore, ['connectedAccounts']);

export const useConnectedAccounts = () => {
  const { connectedAccounts } = usePerformanceState();

  return Object.keys(connectedAccounts)
    .filter((channel) => INTEGRATION_CHANNELS.includes(channel))
    .map((channel) => {
      return connectedAccounts?.[channel].map((account) => ({
        ...account,
        channel,
      }));
    })
    .flat();
};
